import { Button, Form, Select, Space } from "antd";
import { useEffect } from "react";
import SelectDropdownLgIcon from "../../assets/icons/SelectDropdownLgIcon";
import {
  useGetDeviceListQuery,
  useStartEnrollmentInDeviceMutation,
} from "../../features/device/deviceApi";
import useError from "../../hooks/useError";
import { toast } from "../../lib/toast";
import { ModalComponentProps } from "../../types";
import { selectSearchOption, selectStringOption } from "../../utils/utils";
import CustomModal from "../ui/CustomModal";

export default function StartEnrollmentModal({
  handleClose,
  data,
  ...rest
}: ModalComponentProps<string>) {
  const [form] = Form.useForm();
  const {
    isLoading: isDeviceLoading,
    isFetching: isDeviceFetching,
    isError: isDeviceError,
    error: deviceError,
    data: deviceData,
  } = useGetDeviceListQuery({});
  const [startEnrollmentInDevice, { isLoading, isError, error, isSuccess }] =
    useStartEnrollmentInDeviceMutation();
  useError(isDeviceError, deviceError, "Get device data fail");
  useError(isError, error, "Submit failed");

  const onFinish = (values: any) => {
    startEnrollmentInDevice({
      data: values,
      id: Number(data),
    });
  };

  useEffect(() => {
    if (isSuccess) {
      toast("success", "Submitted successfully");
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <CustomModal
      title="Start Enrollment"
      {...rest}
      handleClose={handleClose}
      width={500}
      footer={null}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <Form.Item
          name="deviceIdentifier"
          label="Device Identifier"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please select device",
            },
          ]}
        >
          <Select
            placeholder="Select"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={deviceData?.data?.map((item) => ({
              label: `${item?.location} (${item?.identifier})`,
              value: item?.identifier,
            }))}
            suffixIcon={<SelectDropdownLgIcon />}
            loading={isDeviceLoading || isDeviceFetching}
          />
        </Form.Item>

        <Form.Item
          name="hand"
          label="Select Hand"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please select hand",
            },
          ]}
        >
          <Select
            placeholder="Select"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={selectStringOption(["left", "right"], "string", true)}
            suffixIcon={<SelectDropdownLgIcon />}
          />
        </Form.Item>

        <Form.Item
          name="finger"
          label="Select Finger"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please select finger",
            },
          ]}
        >
          <Select
            placeholder="Select"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={selectStringOption(
              ["thumb", "index", "middle", "ring", "pinky"],
              "string",
              true
            )}
            suffixIcon={<SelectDropdownLgIcon />}
          />
        </Form.Item>

        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading}
          >
            Submit
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}
